export default __webpack_public_path__ + "static/media/404.7a01e437.png";